import TextAreaInput from "../components/Forms/TextAreaInput";
import FileUploadToStorage from "../components/Miscellaneous/FileUploadToStorage";

const neonColors = [
  "#4deeea",
  "#74ee15",
  "#ffe700",
  "#f000ff",
  "#001eff",
  "#4efd54",
  "#04d9ff",
  "#ff9933",
  "#fe4164",
  "#0cff0c",
  "#fe019a",
  "#bc13fe",
  "#ff073a",
  "#cfff04",
  "#ffff33",
  "#fd5f00",
];

const getPublicationTypeFrequency = (publications) => {
  const typeFreq = {};
  let index = 0;
  publications.forEach((publication) => {
    if (publication) {
      if (typeFreq[publication.type]) {
        typeFreq[publication.type] += 1;
      } else {
        typeFreq[publication.type] = 1;
        index = (index + 1) % neonColors.length;
      }
    }
  });
  return typeFreq;
};

const componentWithAddedProp = (Component, addedProps) => {
  return (props) => {
    return <Component {...addedProps} {...props} />;
  };
};

const idField = () => {
  return {
    editable: "never",
    hidden: true,
    searchable: true,
    sorting: true,
    field: "id",
    title: "ID",
  };
};

const textField = (field, title) => {
  return {
    editable: "always",
    searchable: true,
    sorting: true,
    field,
    title,
  };
};

const numericField = (field, title) => {
  const basic = textField(field, title);
  basic["type"] = "numeric";
  return basic;
};

const fileInputField = (field, title, storageInstance) => {
  const basic = textField(field, title);
  basic["editComponent"] = componentWithAddedProp(FileUploadToStorage, {
    buttonLabel: title,
    storageInstance,
  });
  return basic;
};

const textAreaField = (field, title) => {
  const basic = textField(field, title);
  basic["editComponent"] = TextAreaInput;
  return basic;
};

const selectionField = (field, title, selections) => {
  const basic = textField(field, title);
  basic["lookup"] = Object.fromEntries(selections.map((e) => [e, e]));
  return basic;
};

export {
  getPublicationTypeFrequency,
  neonColors,
  componentWithAddedProp,
  idField,
  textField,
  numericField,
  fileInputField,
  textAreaField,
  selectionField,
};
